import type { RegisterFormFields, RegisterFormType, Spouse } from '@/modules/FinancialPlanning/interface/RegisterForm';
import type { FC } from 'react';
import { Flex } from '@eqi-investimentos/react';
import { UseFormReturn } from 'react-hook-form';
import { GenericController } from '@/components/atoms/GenericController';
import { formatCPF, formatPhoneNumber } from '@/utils/masks';
export const SpouseFields: FC<SpouseFieldsProps> = ({
  control,
  errors,
  fields
}) => <Flex direction="column" gap={5} data-sentry-element="Flex" data-sentry-component="SpouseFields" data-sentry-source-file="SpouseFields.tsx">
    {fields.map(({
    id,
    label,
    type,
    options
  }) => {
    const fieldId = id as keyof Spouse;
    return <GenericController<RegisterFormType> key={`spouse.${fieldId}`} {...{
      name: `spouse.${fieldId}`,
      label,
      options,
      errorMessage: errors.spouse?.[fieldId]?.message,
      control,
      type: type === 'number' ? 'text' : type,
      mask: ({
        document: formatCPF,
        phoneNumber: formatPhoneNumber
      } as Record<string, (value: string) => string>)[fieldId] || undefined
    }} />;
  })}
  </Flex>;
type SpouseFieldsProps = Pick<UseFormReturn<RegisterFormType>, 'control' | 'setValue'> & {
  errors: UseFormReturn<RegisterFormType>['formState']['errors'];
  fields: RegisterFormFields[];
};